// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"55":"error-msg","63":"NotFoundPage"}[chunkId] || chunkId) + "." + {"55":"cfa5ace7","63":"bd61a950","453":"c5a13fa0","639":"77c80d3c"}[chunkId] + ".chunk.js";
};